import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=5a5ee3d8&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5ee3d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a5ee3d8')) {
      api.createRecord('5a5ee3d8', component.options)
    } else {
      api.reload('5a5ee3d8', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=5a5ee3d8&scoped=true&", function () {
      api.rerender('5a5ee3d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BYkyZ1tX9mmR/JS/comp/SearchFilterTokens.vue"
export default component.exports